import common from '../../common';

const _draw = Symbol('_draw');
const _onColour_Changed = Symbol('_onColour_Changed');

export default class InkPot{
	constructor() {
		// Constants.
		this.MIN_RADIUS = 5;
		this.MAX_RADIUS = 20;
		// Attributes.
		this._drawLayer = null;
		this._colour = null;
	}

	init(drawLayer) {
		this._drawLayer = drawLayer;
		this._colour = P3.assets.json('game_config').palettePanel.pages[0][0];

		// Signals.
		common.game.scene.palettePanel.signals.onColourChanged.add(this[_onColour_Changed], this);
	}

	onDrawBegan(point){
		this._drawLayer.context.save();
		this._drawLayer.context.lineJoin = this._drawLayer.context.lineCap = 'round';
		this._drawLayer.context.fillStyle = this._colour;

		this[_draw](point, point);

		// Sfx.
		P3.audio.playSound('sfx_tool_inkpot_use_splat_00');
	}

	onDrawMoved(from, to){
		this[_draw](from, to);
	}

	onDrawEnded(){
		this._drawLayer.context.restore();
	}

	[_draw](from, to){
		this._drawLayer.context.beginPath();
		this._drawLayer.context.globalAlpha = Math.random() * 0.25 + 0.15;
		this._drawLayer.context.arc(
			to.x, to.y, P3.math.randomInt(this.MIN_RADIUS, this.MAX_RADIUS), false, Math.PI * 2, false);
		this._drawLayer.context.fill();

		this._drawLayer.onContext_Changed();
	}

	[_onColour_Changed](selection){
		if (selection.indexOf('#') === 0)
			this._colour = selection;
	}

	get paletteItem() {
		return this._colour;
	}
}